module.exports = __webpack_public_path__ + "static/media/Albania - AL.f76aac07.png";